var map = {
	"./austria.svg": 2256,
	"./bangladesh.svg": 57732,
	"./brazil.svg": 389,
	"./brazil2.svg": 31917,
	"./brazil_low.svg": 62966,
	"./brazil_navy.svg": 92748,
	"./canada.svg": 79961,
	"./china.svg": 23632,
	"./china_low.svg": 53347,
	"./colombia.svg": 21565,
	"./colombia_low.svg": 98302,
	"./colombia_navy.svg": 60516,
	"./colombia_navy_low.svg": 9383,
	"./croatia.svg": 21018,
	"./cuba.svg": 44780,
	"./czech.svg": 30892,
	"./denmark.svg": 40631,
	"./empty.svg": 36906,
	"./france.svg": 9974,
	"./france_navy.svg": 55049,
	"./german.svg": 79441,
	"./greece.svg": 14678,
	"./hungary.svg": 47611,
	"./india.svg": 46732,
	"./iran.svg": 14639,
	"./iraq.svg": 53368,
	"./israel.svg": 63199,
	"./israel_low.svg": 10644,
	"./italy.svg": 41612,
	"./japan.svg": 35769,
	"./korea.svg": 89167,
	"./korea_low.svg": 40996,
	"./malaysia.svg": 54462,
	"./mexico.svg": 77106,
	"./mexico_low.svg": 41481,
	"./netherlands.svg": 21225,
	"./netherlands_low.svg": 88266,
	"./north_korea.svg": 99683,
	"./pakistan.svg": 28286,
	"./peru.svg": 12609,
	"./peru_low.svg": 5650,
	"./peru_navy.svg": 99160,
	"./philippine.svg": 10725,
	"./philippine_low.svg": 57238,
	"./poland.svg": 19679,
	"./qatar.svg": 17146,
	"./romania.svg": 36864,
	"./russia.svg": 90892,
	"./russia_low.svg": 85631,
	"./saudi.svg": 92233,
	"./singapore.svg": 77179,
	"./soviet.svg": 39501,
	"./spain.svg": 45034,
	"./sweden.svg": 84295,
	"./sweden_low.svg": 69036,
	"./swiss.svg": 25760,
	"./taiwan.svg": 8531,
	"./thailand.svg": 73138,
	"./turkey.svg": 69245,
	"./uk.svg": 52187,
	"./ukraine.svg": 39122,
	"./us.svg": 33907,
	"./us_low.svg": 96168,
	"./us_white.svg": 15757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28525;